<template>
  <div
    ref="widget-main"
    class="widget-main">
    <section
      class="widget-card"
      :style="{ height: widgetCardHeight }">
      <DecorativePanel />
      <HeaderTitle
        :previous-action="previousAction"
        :user="representativeUser" />
      <router-view />
    </section>

    <div
      ref="external-buttons"
      class="external-buttons">
      <template v-if="$route.name === 'home'">
        <DefaultButton
          v-if="isApplicationAvailable(ApplicationsService.APPOINTMENT_BOOKING)"
          design-type="primary"
          design-variant="default"
          @click="bookAppointment">
          Prendre un rendez-vous entretien <span class="ml-2">&#128197;</span>
        </DefaultButton>

        <DefaultButton
          v-if="isApplicationAvailable(ApplicationsService.TRADEIN_OFFER_REQUEST)"
          design-type="primary"
          design-variant="default"
          @click="requestTadeInOffer">
          Recevoir une offre de reprise <span class="ml-2">&#128182;</span>
        </DefaultButton>

        <DefaultButton
          v-if="isApplicationAvailable(ApplicationsService.MESSENGER)"
          design-type="primary"
          design-variant="default"
          @click="createConversation">
          Démarrer une conversation avec un conseiller <span class="ml-2">&#128172;</span>
        </DefaultButton>
      </template>
      <AssistanceButton v-else-if="$route.name == 'appointment-booking'" />
    </div>
  </div>
</template>

<script>
import {
  mapGetters, mapState
} from "vuex"
import AssistanceButton from "@/components/AssistanceButton"
import ApplicationsService from "@/services/ApplicationsService"
import DecorativePanel from "@/components/ui/DecorativePanel"
import DefaultButton from "@/components/ui/DefaultButton"
import HeaderTitle from "@/components/HeaderTitle"

export default {
  name: "WidgetMain",
  components: {
    AssistanceButton,
    HeaderTitle,
    DecorativePanel,
    DefaultButton,
  },
  data() {
    return {
      ApplicationsService,
      isMounted: false
    }
  },
  computed: {
    ...mapState({
      appOptions: state => state.appOptions,
      isWorkspaceLoaded: state => !!state.workspace,
      representativeUser: state => state.representativeUser
    }),
    ...mapGetters([ "isApplicationAvailable" ]),
    previousAction() {
      return this.$route.name !== "home" ? "home" : null
    },
    widgetCardHeight() {
      if (this.$route.name == "home" || !this.isMounted) {
        return "auto"
      }
      return (this.$refs["widget-main"].clientHeight - this.$refs["external-buttons"].clientHeight) + "px"
    }
  },
  mounted(){
    this.isMounted = true
  },
  created() {
    this.$store.commit("setAppOptions", Object.fromEntries(new URLSearchParams(this.$route.query)))
    document.documentElement.style.setProperty("--theme-color", this.appOptions.themeColor || "#fe4e29")
    this.$store.dispatch("loadWorkspace", this.$route.params.appCode)
  },
  methods: {
    bookAppointment() {
      this.$router.push({ name: "appointment-booking" })
    },
    requestTadeInOffer() {
      this.$router.push({ name: "tradein-offer-request" })
    },
    createConversation() {
      this.$router.push({ name: "conversation" })
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-main {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .widget-card {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: color(plainWhite);
    border-radius: 20px;
    box-shadow: rgba(0, 0, 0, 0.16) 4px 4px 4px;

    &.is-expanded {
      height: 400px;
    }
  }

  .external-buttons {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    *:nth-child(1n) {
      margin-top: 16px;
    }
  }
}
</style>
